// 玩家動作型別（玩家或 AI 透過 CRound.submitAction 送進）
// 從 events.ts 拆出：動作型別與規則 option 同層，讓事件 map（events.ts）反過來 import 它，
// 避免「事件契約檔」被迫反向依賴規則層（ruleset）。

import type {
  TChiOption,
  TKongAddedOption,
  TKongConcealedOption,
  TKongExposedOption,
  TPongOption,
} from './ruleset';
import type { TTile } from './tile';

/** 玩家動作種類 const（discriminator 字串）。 */
export const PlayerActionType = {
  Discard: 'discard',
  Chi: 'chi',
  Pong: 'pong',
  KongExposed: 'kong-exposed',
  KongConcealed: 'kong-concealed',
  KongAdded: 'kong-added',
  Hu: 'hu',
  Pass: 'pass',
  DeclareTenpai: 'declare-tenpai',
} as const;

export type TPlayerActionType = (typeof PlayerActionType)[keyof typeof PlayerActionType];

/**
 * 玩家可送出的所有動作型別。
 * CRound 收到後會驗證合法性、套用狀態變化、發出對應事件。
 */
export type TPlayerAction =
  | {
      readonly type: typeof PlayerActionType.Discard;
      readonly tile: TTile;
      /** AI 出牌後成聽時，讓核心在開放他家反應前同步宣告。 */
      readonly declareTenpai?: boolean;
    }
  | { readonly type: typeof PlayerActionType.Chi; readonly option: TChiOption }
  | { readonly type: typeof PlayerActionType.Pong; readonly option: TPongOption }
  | { readonly type: typeof PlayerActionType.KongExposed; readonly option: TKongExposedOption }
  | { readonly type: typeof PlayerActionType.KongConcealed; readonly option: TKongConcealedOption }
  | { readonly type: typeof PlayerActionType.KongAdded; readonly option: TKongAddedOption }
  | { readonly type: typeof PlayerActionType.Hu }
  | { readonly type: typeof PlayerActionType.Pass }
  | { readonly type: typeof PlayerActionType.DeclareTenpai };
